import React from 'react';

import { useTrackingContext } from '@zapier/toolbox-tracking';

import { LoginBlock } from 'app/developer-v3/teams/team-technical-support-operations/get-help';
import { useFormContext } from 'app/developer-v3/components/PartnerSupportForm/contexts/FormContext';
import {
  AVRO_EVENT_USER_INTERACTION,
  EVENT_CONTACT_LOG_IN,
  EVENT_CONTACT_SIGN_UP,
} from 'app/developer-v3/components/PartnerSupportForm/constants';

const Login = () => {
  const { trackEvent } = useTrackingContext();
  const { size, user } = useFormContext();

  if (user) {
    return null;
  }

  const onClickLogIn = () => {
    trackEvent(EVENT_CONTACT_LOG_IN);
    trackEvent(AVRO_EVENT_USER_INTERACTION, {
      system_name: 'partner_contact_form',
      interaction_name: 'user_login',
      option_selected: 'Log In',
      interaction_raw_text: 'Log In',
      interaction_goal: 'user login',
      event_action: 'click',
    });
  };

  const onClickSignUp = () => {
    trackEvent(EVENT_CONTACT_SIGN_UP, {
      loggedIn: false,
    });
    trackEvent(AVRO_EVENT_USER_INTERACTION, {
      system_name: 'partner_contact_form',
      interaction_name: 'user_signup',
      option_selected: 'Sign Up',
      interaction_raw_text: 'Sign Up',
      interaction_goal: 'user signup',
      event_action: 'click',
    });
  };

  return (
    <LoginBlock
      onClickLogIn={onClickLogIn}
      onClickSignUp={onClickSignUp}
      size={size}
    />
  );
};

export default Login;
